import { useContext } from "react";
import LocaleContext from "../contexts/LocaleProvider";

const useLocale = () => {
  return useContext(LocaleContext);
};

export default useLocale;
